import { render } from "./ContactForm.vue?vue&type=template&id=e8d9b580&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"

import "./ContactForm.vue?vue&type=style&index=0&id=e8d9b580&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8d9b580"

export default script